$button--text-color: var(--button-text-color, #{$white});
$button--bg-color: var(--button-bg-color, #{$black});

:host {
  @include reset-host;
}

:host(.is-full-width-mobile) {
  @include mq('max', 'xs') {
    width: 100%;
  }
}

:host .button {
  display: flex;
  gap: rem(16);
  align-items: center;
  justify-content: center;
  min-height: rem(48);
  padding: 0.5em 1.4em;

  color: $button--text-color;
  font-weight: $fw-medium;
  font-size: $fs-lg;
  font-family: inherit;
  line-height: 1.125;
  text-align: center;
  text-decoration: none;

  background: $button--bg-color;
  border-width: 0;
  border-radius: rem(28);

  cursor: pointer;

  transition: $transition-smooth;
  transition-property: box-shadow, color, border-color;

  @include mq('max', 'xs') {
    width: 100%;
  }

  &:focus-visible {
    outline: 1px solid rgba($black, 0.8);
    outline-offset: 3px;
  }

  &.has-left-icon {
    flex-direction: row-reverse;
  }

  &.is-compact {
    width: rem(40);
    height: rem(40);
    min-height: initial;
    padding: 0;
  }

  &.is-compact-plus {
    width: rem(55);
    height: rem(55);
    min-height: initial;
    padding: 0;

    efb-icon {
      font-size: rem(35);
    }
  }

  &.is-small {
    min-height: rem(30);
    padding: 0.4em 1em;

    font-weight: $fw-bold;
    font-size: $fs-base;
  }

  @each $color-key, $color-value in $theme-colors {
    &.is-variant-#{$color-key} {
      color: map-get($color-value, dark);

      background: map-get($color-value, light);
      box-shadow: 0 0 0 0 map-get($color-value, light);

      &:hover {
        box-shadow: 0 0 0 2px map-get($color-value, light);
      }

      &:focus-visible {
        $color: map-get($color-value, light);
        // @debug type-of($value: $color);

        outline-color: $color;
      }

      &.is-loading:after {
        border-color: map-get($color-value, dark);
        border-top-color: transparent;
      }
    }

    &.has-white-bg {
      background: $white;
      box-shadow: 0 0 0 0 $white;

      &:hover {
        box-shadow: 0 0 0 2px $white;
      }
    }

    &.is-ghost.is-variant-#{$color-key} {
      color: map-get($color-value, default);

      border-color: currentColor;

      &:hover {
        box-shadow: 0 0 0 2px map-get($color-value, default);
      }
    }
  }

  &.is-ghost {
    color: $black;

    background: transparent;
    border: 1px solid;
    border-color: rgba($color-blue-dark, 0.2);

    &:hover {
      box-shadow: 0 0 0 2px rgba($color-blue-dark, 0.2);
    }
  }

  &.is-ghost.is-compact,
  &.is-ghost.is-compact-plus {
    border-width: 2px;
  }

  &.is-full-width {
    width: 100%;
  }

  &.is-loading {
    position: relative;

    pointer-events: none;

    &:after {
      position: absolute;
      top: 50%;
      left: 50%;

      width: rem(20);
      height: rem(20);

      border-style: solid;
      border-width: 2px;
      border-radius: 50%;
      transform: translate(-50%, -50%);

      animation: loading-spin 0.7s linear infinite;

      content: '';
    }

    .text {
      opacity: 0;
    }
  }
}

@keyframes loading-spin {
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }

  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
